








































import Vue from "vue";
import ColorPickerMenu from './ColorPickerMenu.vue';
import { CardColorTypes } from '../store/enums'
import { CardColors } from '../store/model' 
import { SnackbarColorTypes } from "@/store/enums";
export default Vue.extend({
  components: {
    ColorPickerMenu,
  },
  data: () => ({
    note: {
      title: "",
      content: "",
      color: CardColorTypes.Default
    },
    titleFieldVisible: false,
    actionsVisible: false,
  }),
  methods: {
    showTitleAndActions() {
      this.titleFieldVisible = true;
      this.actionsVisible = true;
    },
    hideTitleandActions() {
      this.titleFieldVisible = false;
      this.actionsVisible = false;
    },
    colorSelected(color: CardColors){
        return this.note.color = CardColorTypes[color]
    },
    onClickOutside() {
        if(!this.colorMenuOpen){
            this.close();
        }
    },
    close() {
      this.hideTitleandActions();

      if (this.note.title || this.note.content) {
        this.$store.dispatch("notes/addNote", this.note);
        this.$store.dispatch("global/showSnackbar", {
          open: true,
          text: 'Note saved',
          color: SnackbarColorTypes.Success
        })
      }

      this.note = {
        title: "",
        content: "",
        color: CardColorTypes.Default
      };
    },
  },
  computed: {
      colorMenuOpen(){
        return this.$store.getters['global/colorMenuOpen']
      }
  }
});
